import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const ContactsLink = () => {

  return (
    <AsideMenuLink
      pathname={P.CONTACTS_PAGE}
      subject={S.CONTACTS_PAGE}
      icon={'User_orange.svg'}
      label={<FormattedMessage id="contacts-page-link" defaultMessage="Contacts"/>}
    />
  );
};

export default ContactsLink;
